import theme from 'clad-ui/theme/chotot';
import { styled } from 'linaria/react';
import React from 'react';
const Wrapper = /*#__PURE__*/styled("div")({
  name: "Wrapper",
  class: "w1psf6ov"
});
const Title = /*#__PURE__*/styled("h2")({
  name: "Title",
  class: "tm4q1bl"
});
const CollectionWrapper = /*#__PURE__*/styled("div")({
  name: "CollectionWrapper",
  class: "cwgwn50"
});
const ItemLink = /*#__PURE__*/styled("a")({
  name: "ItemLink",
  class: "i1tznitr"
});
const ItemImage = /*#__PURE__*/styled("img")({
  name: "ItemImage",
  class: "im6bhq"
});
const JobCollection = props => {
  const {
    collections: {
      quick_shortcut: quickShortcut = [],
      description = 'Việc làm may theo quận'
    },
    onClickItem,
    isDone
  } = props;
  const handleClick = (item, index) => {
    if (onClickItem) {
      onClickItem(item, index);
    }
  };
  return isDone && quickShortcut.length === 0 ? null : <Wrapper>
      <Title>{description}</Title>
      <CollectionWrapper>
        {quickShortcut.map((item, index) => <ItemLink href={item.web_url} key={`${item.text}-${index}`} onClick={() => handleClick(item, index)}>
            <ItemImage src={item.image} alt={item.text} />
          </ItemLink>)}
      </CollectionWrapper>
    </Wrapper>;
};
export default JobCollection;

require("../../../.linaria-cache/src/components/JobCollection/JobCollection.linaria.module.css");